import classNames from "classnames"
import styles from "../../../../styles/LandingPage/Patients.module.scss"
import wave from "../../../../styles/LandingPage/Waves.module.scss"
import { FC } from "react"
import { SectionProps } from "./SectionType"

const SectionThree: FC<SectionProps> = ({
  children,
  className,
  waveBottom = true,
  waveTop = true,
  waveColorTop,
  waveColorBottom,
  backgroundColor = "rgba(255, 246, 241, 1)",
}) => {
  return (<section
    style={{
      backgroundColor: backgroundColor,
    }}
    className={classNames(styles.sectionMedium, className)}
  >
    {waveTop && <div className={wave.twoTop}>
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path
          d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
          style={{ fill: waveColorTop }}
          className={wave.shapeFill}
        ></path>
      </svg>
    </div>}
    {children}
    {waveBottom && <div className={wave.twoBottom}>
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path
          d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
          style={{ fill: waveColorBottom }}
          className={wave.shapeFill}
        ></path>
      </svg>
    </div>}
  </section>)
}

export default SectionThree
